import { Tooltip, type TooltipRootProps } from "@heroui/react";

/**
 * Constrained tooltip root props.
 * Tooltip root is a logical wrapper (TooltipTrigger) — no DOM element rendered.
 */
export type AppTooltipProps = Omit<TooltipRootProps, "className">;

/**
 * AppTooltip root — logical wrapper for tooltip trigger.
 */
function AppTooltipRoot(props: AppTooltipProps) {
  return <Tooltip {...props} />;
}

/**
 * AppTooltip — Design system tooltip.
 *
 * Wraps HeroUI v3 Tooltip. No custom variants — styling is handled by
 * the Rosé Pine CSS theme. Sub-components (Trigger, Content, Arrow) are
 * HeroUI pass-throughs.
 *
 * @example
 * ```tsx
 * <AppTooltip>
 *   <AppTooltip.Trigger>
 *     <AppButton variant="tertiary">Hover me</AppButton>
 *   </AppTooltip.Trigger>
 *   <AppTooltip.Content>Tooltip text</AppTooltip.Content>
 * </AppTooltip>
 * ```
 */
export const AppTooltip = Object.assign(AppTooltipRoot, {
  Trigger: Tooltip.Trigger,
  Content: Tooltip.Content,
  Arrow: Tooltip.Arrow,
});
